var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeauturedIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#191919"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0003 27.1277L30.3337 33.7944L27.0003 30.461M45.3337 29.0694C45.3337 40.0165 37.0535 44.9245 33.5433 46.5133L33.5389 46.5153C33.1697 46.6824 32.9846 46.7661 32.5651 46.8382C32.2994 46.8838 31.7029 46.8838 31.4372 46.8382C31.016 46.7659 30.829 46.6818 30.4569 46.5133C26.9467 44.9245 18.667 40.0165 18.667 29.0694V22.4613C18.667 20.5945 18.667 19.6604 19.0303 18.9473C19.3499 18.3201 19.8594 17.8106 20.4867 17.491C21.1997 17.1277 22.1338 17.1277 24.0007 17.1277H40.0007C41.8675 17.1277 42.7996 17.1277 43.5126 17.491C44.1399 17.8106 44.6511 18.3201 44.9707 18.9473C45.3337 19.6597 45.3337 20.5927 45.3337 22.4559V29.0694Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeauturedIcon4);
export default __webpack_public_path__ + "static/media/feauturedIcon4.ab6180c7299d685e705cc913e3f75602.svg";
export { ForwardRef as ReactComponent };